import script from "./LowProductionWithoutMovimentation.vue?vue&type=script&setup=true&lang=js"
export * from "./LowProductionWithoutMovimentation.vue?vue&type=script&setup=true&lang=js"

import "./LowProductionWithoutMovimentation.vue?vue&type=style&index=0&id=5f6b5cde&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6b5cde"]])

export default __exports__
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFooter,QToolbar,QLinearProgress,QBtn,QPageContainer,QPage,QOptionGroup,QTabPanels,QTabPanel,QInput,QSelect,QItem,QItemSection,QRadio});
